import { render, staticRenderFns } from "./GenderPage.vue?vue&type=template&id=08c3daa4"
import script from "./GenderPage.vue?vue&type=script&lang=js"
export * from "./GenderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports